import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message,Image } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import "./index.scss"
import { getRequest } from '../../utils/request';

const buttonLayout = {
  wrapperCol: {
    offset: 10,
    span: 16
  }
}

const App: React.FC = () => {

  const [form] = Form.useForm()
  const [registerForm] = Form.useForm()


  const [messageApi, contextHolder] = message.useMessage();
  const [imageCodeBase64, setImageCodeBase64] =  useState('');
  const [count, setCount] = useState(60)
  const [liked, setLiked] = useState(true)
  const [iscard, setIsCard] = useState(true)
  const key = "login"
  // 成功提示
  const success = (text: string) => {
    messageApi.open({
      type: 'success',
      content: text,
    });
  };

  // router Hooks
  const navigate = useNavigate()

  // 登录提交
  const submitData = async () => {
    message.open({
      key,
      type: 'loading',
      content: '正在登录中...',
    });
    const data = form.getFieldsValue()
    axios.get("/work/wxLogin",{
      params: { ...data, type: "非上门" }
    }).then((res: any) => {
      if (res.data.code == 0) {
        localStorage.setItem("token", res.headers.authorization)
        localStorage.setItem("isLogin", "1")
        localStorage.setItem("city", res.data.data.city)
        localStorage.setItem("userId", res.data.data.id)
        const roleName = res.data.data.roleName;
        if (roleName && roleName[0]) {
          localStorage.setItem("roleName", roleName[0])
        }
        message.open({
          key,
          type: 'success',
          content: '登录成功!',
          duration: 1,
        });
        if (roleName && (roleName[0] === 'huiju' || roleName[0] === 'proxy')) {
          navigate("/sfthome/1/10/0")
        } else {
          navigate("/home/1/10/0")
        }
      } else {
        message.open({
          key,
          type: 'error',
          content: res.data.message,
          duration: 1,
        });
        if (res.data.message == "用户需要注册") {
          setIsCard(false)
        }
      }
    })
  };

  // 注册提交
  const submitRegister = async () => {
    message.open({
      key,
      type: 'loading',
      content: '正在注册中...',
    });
    const data = form.getFieldsValue()
    axios.get("/work/master/user/verCode",{
      params :  {...data}
    }).then((res:any) => {

      if (res.data.code == 0) {
        localStorage.setItem("token", res.headers.authorization)
        localStorage.setItem("isLogin", "1")
        localStorage.setItem("city", res.data.city)
        localStorage.setItem("userId", res.data.id)
        message.open({
          key,
          type: 'success',
          content: '注册成功!',
          duration: 1,
        });
        navigate("/home/1/10/0")
      }else{
        message.open({
          key,
          type: 'error',
          content: res.data.message,
          duration: 1,
        });
      }
    })
  };



const getCode = async () => {
  const data = form.getFieldsValue()

  if (!data.phone) {
    message.error("请输入正确的手机号!")
    return
  }
  if (!data.imageCode) {
    message.error("请输入正确的图形验证码!")
    return
  }

  try {
    // 1. 先验证图形验证码（同步执行）
    let resver = await getRequest("/work/master/user/verCaptchaImage", data)

    if (resver.code !== 0) {
      // 图形验证码验证失败，直接返回
      message.error("图形验证码错误!")
      return
    }

    // 2. 图形验证码验证成功后，启动倒计时
    setLiked(false)
    const timer = setInterval(() => {
      setCount(old => {
        if (old === 1) {
          setLiked(true)
          clearInterval(timer)
          return 60
        } else {
          return old - 1
        }
      })
    }, 1000)

    // 3. 在倒计时启动后，获取短信验证码
    let res = await getRequest("/work/master/user/getCode", data)
    if (res.code === 0) {
      message.success("获取验证码成功")
    } else {
      // 如果获取验证码失败，清除倒计时
      clearInterval(timer)
      setLiked(true)
      setCount(60)
    }

  } catch (error) {
    // 异常处理
    message.error("操作失败，请重试")
  }
}
  // 手机号输入变化时加载图形验证码
  const handlePhoneChange = (value) => {
    if (value && value.length === 11) {
      getImageCode(value);
    }
  }

  // 刷新图形验证码
  const refreshImageCode = () => {
    const data = form.getFieldsValue();
    if (data.phone && data.phone.length === 11) {
      getImageCode(data.phone);
    } else {
      message.warning("请先输入有效的手机号");
    }
  };

  // 获取图形验证码
  const getImageCode = async (id: string) => {
    try {
      let res = await getRequest("/work/master/user/captchaImage", { id });

      if (res.code === 0 && res.data) {
        // 兼容Base64前缀
        if (res.data.startsWith('data:image/')) {
          setImageCodeBase64(res.data);
        } else {
          const validBase64 = res.data.replace(/\s/g, '');
          const imgUrl = `data:image/jpeg;base64,${validBase64}`;
          setImageCodeBase64(imgUrl);
        }
      } else {
        message.error("获取图形验证码失败：" + (res.message || "接口返回异常"));
        setImageCodeBase64('');
      }
    } catch (err) {
      console.error("获取图像码失败：", err);
      message.error("获取图形验证码失败，请重试");
      setImageCodeBase64('');
    }
  };

  return (
    <div className='login-form'>
      {contextHolder}
      <div style={{ "textAlign": "center", 'marginBottom': "20px" }}>
        <h1>登录客服</h1>
      </div>
      {
        iscard ? (
          <Form
            name="normal_login"
            form={form}
            onFinish={submitData}
            layout="vertical"
          >
            {/* 手机号输入框 */}
            <Form.Item
              name="phone"
              rules={[{ required: true, message: '请输入手机号!' }]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="手机号"
                onChange={(e) => handlePhoneChange(e.target.value)}
                size="middle"
              />
            </Form.Item>

            {/* 图形验证码行 - 核心：同一行展示 */}
            <Form.Item
              name="imageCode"
              rules={[{ required: true, message: '请输入图形验证码!' }]}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Input
                  placeholder="图形验证码"
                  maxLength={6}
                  size="middle"
                  style={{ flex: 1 }}
                />
                <Image
                  src={imageCodeBase64}
                  alt="图形验证码"
                  style={{
                    width: '180px',
                    height: '32px',
                    cursor: 'pointer',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px'
                  }}
                  onClick={refreshImageCode}
                  fallback="https://via.placeholder.com/100x32?text=点击刷新"
                  preview={false}
                />
              </div>
            </Form.Item>

            {/* 短信验证码行 */}
            <Form.Item
              name="verCode"
              rules={[{ required: true, message: '请输入短信验证码!' }]}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Input
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="短信验证码"
                  maxLength={6}
                  size="middle"
                  style={{ flex: 1 }}
                />
                <Button
                  type={liked ? "primary" : "default"}
                  onClick={getCode}
                  disabled={!liked}
                  size="middle"
                  style={{
                    width: '180px',
                    flexShrink: 0
                  }}
                >
                  {liked ? '获取验证码' : `${count}秒`}
                </Button>
              </div>
            </Form.Item>

            {/* 登录按钮 */}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="middle"
                style={{ width: '100%', height: '36px' }}
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        ) : (
          // 注册表单
          <Form
            name="register_form"
            form={registerForm}
            onFinish={submitRegister}
            layout="vertical"
          >
            <Form.Item
              name="phone"
              rules={[{ required: true, message: '请输入手机号!' }]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="手机号"
                size="middle"
              />
            </Form.Item>

            <Form.Item
              name="code"
              rules={[{ required: true, message: '请输入验证码!' }]}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Input
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="验证码"
                  size="middle"
                  style={{ flex: 1 }}
                />
                <Button
                  type={liked ? "primary" : "default"}
                  onClick={getCode}
                  disabled={!liked}
                  size="middle"
                  style={{
                    width: '180px',
                    flexShrink: 0
                  }}
                >
                  {liked ? '获取验证码' : `${count}秒`}
                </Button>
              </div>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="middle"
                style={{ width: '100%', height: '36px' }}
              >
                注册
              </Button>
            </Form.Item>
          </Form>
        )
      }
    </div>
  );
};

export default App;
